/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import useToggle from '../../hooks/useToggle';

function PasswordField({
  label,
  className,
  labelstyle,
  labeldarkstyle,
  classNamedark,
  eyeiconstyle,
  fieldName,
  register,
  errors,
  placeHolder,
  isRequired,
  minimLength,
  maxLength,
  mandatory,
  hideErrors,
  pattern,
  patternMessage,
  validate,
}) {
  let classNames = labelstyle;
  let classNamess = className;

  if (localStorage.getItem('theme') === 'dark') {
    classNames = labeldarkstyle;
    classNamess = classNamedark;
  }
  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };
  const [type, setType] = useToggle();

  const labelText = label ?? 'Password';
  const minLen = hideErrors ? 0 : minimLength ?? 8;
  const registerOptions = {
    required: {
      value: isRequired,
      message: `${labelText} is required.`,
    },
    minLength: {
      value: minLen,
      message: `${labelText} must be at least ${minLen} characters.`,
    },
    ...(maxLength != null && {
      maxLength: {
        value: maxLength,
        message: `${labelText} must be no more than ${maxLength} characters.`,
      },
    }),
    ...(pattern && {
      pattern: {
        value: pattern,
        message: patternMessage || `${labelText} must contain at least one letter and one number.`,
      },
    }),
    ...(validate && { validate }),
  };

  return (
    <div className="form-group">
      <label htmlFor={fieldName} className={classNames ?? labelstyle}>
        {label ?? ''}
      </label>
      {mandatory || isRequired ? (
        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
      ) : (
        <span />
      )}
      <input
        type={type ? 'text' : 'password'}
        className={classNamess ?? className}
        onKeyDown={handleKeyDown}
        placeholder={placeHolder}
        data-toggle="tooltip"
        data-placement="top"
        title="Password must be at least 8 characters and contain at least one letter and one number"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...register(fieldName, registerOptions)}
      />
      <span className={eyeiconstyle ?? 'password_show'} onClick={setType}>
        {!type ? <i className="fa fa-eye-slash" /> : <i className="fa fa-eye" />}
      </span>
      <p
        style={{
          color: 'red',
          marginTop: '5px',
          fontSize: '14px',
        }}
      >
        {' '}
        {
          // Shows if error exist
          errors[fieldName] && errors[fieldName].message
        }{' '}
      </p>
    </div>
  );
}

PasswordField.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string.isRequired,
  eyeiconstyle: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  placeHolder: PropTypes.string,
  isRequired: PropTypes.bool,
  minimLength: PropTypes.number,
  maxLength: PropTypes.number,
  labelstyle: PropTypes.string.isRequired,
  mandatory: PropTypes.bool,
  labeldarkstyle: PropTypes.string,
  classNamedark: PropTypes.string,
  hideErrors: PropTypes.bool,
  pattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),
  patternMessage: PropTypes.string,
  validate: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
PasswordField.defaultProps = {
  mandatory: false,
  isRequired: false,
  labeldarkstyle: null,
  classNamedark: null,
  label: 'Password',
  placeHolder: 'Password',
  minimLength: 8,
  maxLength: undefined,
  hideErrors: false,
  pattern: undefined,
  patternMessage: undefined,
  validate: undefined,
};
export default PasswordField;
